import { createSlice } from '@reduxjs/toolkit';

export const necessaryCookiesSlice = createSlice({
	name: 'necessaryCookies',
	initialState: {
		necessaryCookies: false,
	},
	reducers: {
		setNecessaryCookies: (state) => {
			state.necessaryCookies = !state.necessaryCookies;
		},
	},
});

export const { setNecessaryCookies } = necessaryCookiesSlice.actions;

export default necessaryCookiesSlice.reducer;
